import { useStore } from "vuex";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { toast } from "vue-sonner";

export default function useBulkEditorCustomColumnActions(selectedRows) {
  const store = useStore();
  const route = useRoute();
  const categoryID = computed(() => route.params.categoryID);

  const createBulkPatchUpdates = (attribute, value) => {
    if (!categoryID.value) {
      console.error("Category ID is missing for bulk patch.");
      return [];
    }

    return (selectedRows.value || []).map((item) => ({
      path: item.path,
      update: { [attribute]: value },
      categoryID: categoryID.value,
      entryID: item.path.split("entry/")[1],
    }));
  };

  const dispatchBulkUpdate = async (updates) => {
    try {
      await store.dispatch("api/patchEntriesBulk", {
        updates,
        opts: { updateStoreFirst: true },
      });
      toast.success("Success!");
    } catch (error) {
      console.error(
        `Failed to perform bulk editor custom column action`,
        error
      );
    }
  };

  const executeCustomMenuAction = async (actionPayload) => {
    const { action } = actionPayload;
    if (!selectedRows.value?.length) {
      return;
    }

    let updates = [];

    switch (action) {
      case "setUseSlideshow":
        updates = createBulkPatchUpdates("useSlideshowForPdf", true);
        break;
      case "setUseYearbook":
        updates = createBulkPatchUpdates("useSlideshowForPdf", false);
        break;
      default:
        console.warn(`Unhandled custom menu action: ${action}`);
        return;
    }

    if (updates.length > 0) {
      await dispatchBulkUpdate(updates);
    }
  };

  return {
    executeCustomMenuAction,
  };
}
